export default "/ezETH-wstETH-BPT.0f7fc69e32c37e91a6946cc422dcd718.png";